module.exports = __webpack_public_path__ + "static/img/default_photo.d1d6e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/default_photo.png
// module id = TciL
// module chunks = 1